import { useEffect } from 'react';
import { Marker } from 'wavesurfer.js/src/plugin/markers';

import { StoryConfig } from 'services/story.service';
import { RootState } from 'store/store';
import { useAppSelector, useAppStore } from 'store/store-hooks';
import { isNull } from 'components/app/_helpers/_app.helper';
import { IntroKeys } from 'components/app/intro/intro-keys';
import {
  getRangeMarkers,
  setRangeRegionsClass,
  getMarkersEnabledRange,
  getRangeMarkerTimes,
} from './range-markers.helper';

import audioTrackStyles from 'components/app/audio-track/_audio-track.module.scss';

interface IMarker extends Marker {
  el: HTMLElement;
}

export const useRangeMarkersFc = (ws: WaveSurfer) => {
  const { id } = useAppSelector((state) => state.fc__data);
  const store = useAppStore();

  const setRangeMarkers = (config: StoryConfig, markers: number[] | null) => {
    if (!markers || !config) return;

    ws.clearMarkers();
    const { startTime, endTime } = getRangeMarkerTimes({
      startMarkerId: config.startMarkerId,
      finishMarkerId: config.finishMarkerId,
      duration: ws.getDuration(),
      markers,
    });

    getRangeMarkers(startTime, endTime, false).forEach((marker) => {
      if (marker.position === 'top' && isNull(config.startMarkerId)) return;
      if (marker.position === 'bottom' && isNull(config.finishMarkerId)) return;

      const newMarker: IMarker = ws.addMarker(marker);

      newMarker.el.classList.remove(audioTrackStyles['marker-fixed']);
      newMarker.el.classList.add(audioTrackStyles['marker-fixed']);

      // Add data-intro attributes for tutorial highlighting
      if (marker.position === 'top') {
        newMarker.el.setAttribute('data-intro', String(IntroKeys.startRangeMarker));
      } else if (marker.position === 'bottom') {
        newMarker.el.setAttribute('data-intro', String(IntroKeys.endRangeMarker));
      }
    });
  };

  useEffect(() => {
    if (!id) return;

    const { fcMarkers, fcStoryConfig } = selectData(store.getState());

    setRangeMarkers(fcStoryConfig!, fcMarkers);
    setRangeRegionsClass(getMarkersEnabledRange(fcStoryConfig, fcMarkers?.length, 'marker'), ws);
  }, [id]);
};

/* S E L E C T O R */

const selectData = (state: RootState) => {
  const { fcMarkers, fcStoryConfig } = state.fc__data;
  return {
    fcMarkers,
    fcStoryConfig,
  };
};
